/**
* Validators
* --------------
* A collection of validators for inputs like emails, passwords ect.
* Mainly used in login, forgot password, and reset password.
*/

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string): boolean => emailRegex.test(email);

export const validatePassword = (password: string): boolean => {
  const hasMinLength = password.length >= 8;
  const hasUpperCase = /[A-Z]/.test(password);
  const hasLowerCase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);

  return hasMinLength && hasUpperCase && hasLowerCase && hasNumber;
};

export const calculatePasswordStrength = (password: string): number => {
  if (!password) {
    return 0;
  }

  let strength = 0;

  if (password.length >= 8) strength += 20;
  if (password.length >= 12) strength += 10;

  if (/[A-Z]/.test(password)) strength += 20; // Has uppercase
  if (/[a-z]/.test(password)) strength += 15; // Has lowercase
  if (/[0-9]/.test(password)) strength += 15; // Has number
  if (/[^A-Za-z0-9]/.test(password)) strength += 20; // Has special char

  return Math.min(100, strength);
};

export const getPasswordStrengthLabel = (strength: number): string => {
  if (strength === 0) return "";
  if (strength < 25) return "Weak";
  if (strength < 50) return "Fair";
  if (strength < 70) return "Good";
  if (strength < 90) return "Strong";
  return "Very Strong";
};

export const getPasswordStrengthColor = (strength: number): string => {
  if (strength === 0) return "bg-transparent";
  if (strength < 25) return "bg-red-500";
  if (strength < 50) return "bg-orange-500";
  if (strength < 70) return "bg-yellow-500";
  if (strength < 90) return "bg-green-500";
  return "bg-emerald-500";
};

